export enum InvoiceCatTipoFactor {
  'Tasa' = 'Tasa',
  'Cuota' = 'Cuota',
  'Exento' = 'Exento',
}
